import React from 'react'

import { Wrapper } from './Blocker.styles'

/**
 * NOTE: This component needs to be places inside of a container with
 *       positioning.
 */
const Blocker = () => {
  // @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
  const onDisableScroll = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return <Wrapper onScroll={onDisableScroll} />
}

export default Blocker
